var Doosan = Doosan || {};

Doosan.Salesforce = (function() {
    function timestamp(form) {
        var response = $('.g-recaptcha-response', form).val();

        if (response == null || response.trim() == "") {
            var captchaSettings = $('input[name="captcha_settings"]', form);
            var elems = JSON.parse(captchaSettings.val());
            elems["ts"] = JSON.stringify(new Date().getTime());
            captchaSettings.val(JSON.stringify(elems));
        }
    }

    function enableCaptcha(form) {
        setInterval(function() {
            timestamp($(form));
        }, 500); 
    }
	
    function enableGeocoding(form, opts) {
        // enable geocoding of zipcode on blur to try to automatically select
        // the correct state, and country

		var options = $.extend({
			zipSelector: '#zip',
			stateSelector: '#state',
			countrySelector: '#country'
		}, opts);
		
		$(form).find(options.zipSelector).blur(function() {
			var zip = $(this).val();
			var country = Doosan.Validation.isUnitedStatesZipCode(zip)
				? 'US'
				: 'CA';
				
            Doosan.Geocoder.getLocationComponentsFromZipcode(zip, country)
				.done(function(result) {
					if (result.state !== null) {
						$(form).find(options.stateSelector)
							.find('option').attr('selected', null)
							.filter('option[value="' + result.state + '"]').attr('selected', true);
					}
					
                    if (result.country !== null) {
                        $(form).find(options.countrySelector)
                            .find('option').attr('selected', null)
                            .filter('option[value="' + result.country + '"]').attr('selected', true);
                    }
				})
				.fail(function(err) {
					console.log(err);
				});
		});
    }

    function applyStyles(form) {
        $(form).find(':checkbox').doosanCheckbox();
    }

    function enableValidation(form, opts) {
        var options = $.extend({
            countrySelector: 'select[name="country"]',
            equipmentGroupSelector: '.equipment-group',
            validationConfigurationCallback: null
        }, opts);

        var equipmentFieldNames = [
            '00N5e00000efeah', // articulated dump trucks
            '00N5e00000efeai', // attachment
            '00N5e00000efean', // crawler excavator
            '00N5e00000efeaq', // log loader excavator
            '00N5e00000efear', // material handler
            '00N5e00000efeas', // mini excavator
            '00N5e00000efeb0', // wheel excavator
            '00N5e00000efeb1'  // wheel loader
        ];

        var isEquipmentRequired = $(form).find(options.equipmentGroupSelector).hasClass('required');

        var validationConfiguration = {
            rules: {
                'phone': {
                    required: true,
                    phoneUS: true
                },

                'zip': {
                    required: true,
                    postalCodeCA: {
                        depends: function(element) {
                            return $(form).find(options.countrySelector).val() === 'CA';
                        }
                    },
                    zipcodeUS: {
                        depends: function(element) {
                            return $(form).find(options.countrySelector).val() === 'US';
                        }
                    }
                },

                'state': {
                    required: true
                },

                'country': {
                    required: true
                },

                // customer type
                '00N22000001Ka2I': 'required',

                // market category
                '00N22000001Ka1a': 'required',

                // Usage type
                '00N1300000B3bCO': 'required',  // older saleforce id
                '00N5e00000efeXg': 'required',

                // Business type
                '00N30000003VsCe': 'required',  // older saleforce id
                '00N5e00000efeVk': 'required'

            },

            messages: {
                '00N22000001Ka2I': $.validator.messages.required,
                '00N22000001Ka1a': $.validator.messages.required,
                '00N30000002x86J': $.validator.messages.selectAValue,
                '00N5e00000efeXg': $.validator.messages.required,
                '00N1300000B3bCO': $.validator.messages.required,
                '00N30000003VsCe': $.validator.messages.required,
                '00N5e00000efeVk': $.validator.messages.required

            },

            errorPlacement: function(error, element) {
                if (equipmentFieldNames.indexOf(element.attr('name')) > -1) {
                    // only display the error message for the last equipment field failing validation
                    var list = $(element).parents(options.equipmentGroupSelector);
                    list.next().remove();
                    list.after(error);
                } else {
                    error.insertAfter(element);
                }
            }
        };

        if (isEquipmentRequired) {
            for (var i = 0; i < equipmentFieldNames.length; i++) {
                var name = equipmentFieldNames[i];

                validationConfiguration.rules[name] = {
                    require_from_group: [1, '.equipment-item']
                };

                validationConfiguration.messages[name] = {
                    require_from_group: $.validator.messages.selectEquipmentCategory
                };
            }
        }

        if (options.validationConfigurationCallback !== null) {
            options.validationConfigurationCallback(validationConfiguration);
        }

        $(form).validate(validationConfiguration);
    }

    function initForm(form, opts) {
        var options = $.extend({
            validation: null,
            applyStyles: true
        }, opts);

        Doosan.Salesforce.enableCaptcha(form);
        Doosan.Salesforce.enableGeocoding(form);

        if (options.applyStyles) {
            Doosan.Salesforce.applyStyles(form);
        }

        Doosan.Salesforce.enableValidation(form, options.validation);
    }

    function createRecaptchaCallback(form) {
        var submitBtn = $(form).find(':submit');
        submitBtn.attr('disabled', true);

        return function(token) {
            submitBtn.attr('disabled', null);
        };
    }

    return {
        enableCaptcha: enableCaptcha,
        enableGeocoding: enableGeocoding,
        applyStyles: applyStyles,
        enableValidation: enableValidation,
        initForm: initForm,
        createRecaptchaCallback: createRecaptchaCallback
    };
})();